<template>
    <van-overlay
        :show="show"
        class="app-loader-overlay"
    >
        <div class="app-loader-content">
            <img
                src="@/assets/images/HUD.gif"
                alt="Loading"
                class="loader-image"
            />
            <!-- <p class="loader-text">Loading<span class="dots"></span></p> -->
        </div>
    </van-overlay>
</template>

<script>
export default {
    name: "AppLoader",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
/* === Overlay background === */
.app-loader-overlay {
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    transition: all 0.3s ease-in-out;
}

/* === Loader content === */
.app-loader-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: #fff;
    text-align: center;
    animation: fadeInUp 0.4s ease-in-out;
}

/* === Image === */
.loader-image {
    width: 100px;
    height: 100px;
    object-fit: contain;
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));
    animation: bounce 1.8s infinite ease-in-out;
}

/* === Text === */
.loader-text {
    font-size: 1.1rem;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: #f5f5f5;
    font-family: "Poppins", sans-serif;
    margin-top: 5px;
}

/* animated "..." dots */
.dots::after {
    content: "";
    animation: dots 1.2s steps(3, end) infinite;
}

/* === Animations === */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-8px);
    }
}

@keyframes dots {
    0% {
        content: "";
    }

    33% {
        content: ".";
    }

    66% {
        content: "..";
    }

    100% {
        content: "...";
    }
}
</style>
